import { shouldSuppressStaleClientBundleError } from '@joyful/ui/app'
import { RouteErrorState } from '@joyful/ui/core'

export interface ErrorProps {
  error: number
}

export interface ErrorRouteFallbackProps {
  error: unknown
}

export function ErrorRouteFallback({ error }: ErrorRouteFallbackProps) {
  if (error instanceof Error && shouldSuppressStaleClientBundleError(error)) {
    return null
  }

  return <ErrorRoute error={500} />
}

export function ErrorRoute({ error }: ErrorProps) {
  return (
    <RouteErrorState
      title={
        error === 404
          ? `Looks like we took a wrong turn.`
          : `Whoops, something went wrong.`
      }
      description={
        error === 404
          ? `We can't find the page you're looking for. Head back to the main page and try again.`
          : `We're working on fixing this. Head back to the main page and try again.`
      }
    />
  )
}
